import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { getFormValidatorErrText } from "@/utils/utils"
import { globalPrompt } from "@/components/message";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModel";
import { useGlobalModel, transOptions } from "@/model/globalModel";
import { useDictModel } from "../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { DetailType } from "@/types/ScmEnums";
import { vehicleService } from "../../../../base/customerFiles/vehicle/vehicleService"
import { IVehicleDetail, IVehicleFields } from "../../../../base/customerFiles/vehicle/vehicleType"

import { ISelectOption } from "@/components/YhFormBox/Types";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    IYhFormRef: React.MutableRefObject<IYhFormRef | undefined>
}
//返回列表韦options的格式
export const vehicleOption = (list: any[]) => {
    return list.length != 0 ? list.map(item => ({ label: item.label, value: item.value })) : []
}
export const FormBox: FC<ITopType> = ({ id, mode, IYhFormRef }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { CustomerData, technicianData, vehicleData, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { detailEditForm, detailAddForm, detailLookForm, vehicleAddAll, vehicleEditAll, setVehicleAddAll, setVehicleEditAll, updateAddFormVal, updatEditFormVal, getDetailEditOne, resetAddCatch, resetEditCatch } = useMaintenanceDetailsModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName } = useDictModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    // const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    // const [addVehicleList, setAddVehicleList] = useState<IVehicleDetail[]>(vehicleAll)
    // const [editVehicleList, setEditVehicleList] = useState<IVehicleDetail[]>(vehicleAll)

    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode == DetailType.edit) {
            getDetailEditOne(id, mode)
        }
        mode == DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])

    const goCustomer = () => {
        replaceNav(
            selectedNavId,
            "13-5-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const goVehicle = () => {
        replaceNav(
            selectedNavId,
            "13-5-2-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    useEffect(() => {
        return () => {
            !findNav("2-5-1") && resetAddCatch(mode);
            !findNav("2-5-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])

    useEffect(() => {
        getVehicleAllList()
    }, [mode])

    const getVehicleAllList = async (param?: IVehicleFields) => {
        let params = {
            ...param,
            pageSize: 1000,
            pageNum: 1
        }
        const { retData } = await vehicleService.page(params)
        const { records } = retData
        if (records.length == 0) { globalPrompt("message", { text: "该客户下没有车辆，点击左侧车辆牌照去新增吧!", type: "warning" }) }
        let newRecords = records.map(item => {
            return {
                ...item,
                label: item.licensePlate,
                value: item.licensePlate
            }
        })
        mode == "add" ? setVehicleAddAll(newRecords) : setVehicleEditAll(newRecords)
    }
    const wsChangs = async (value: string, option: ISelectOption,) => {
        getVehicleAllList({ customerName: option.label })
    }
    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="statu-blue" onClick={goCustomer}>{Locale["Customer"]}</span>,
                fieldName: "customerCode",
                onSelectChange: wsChangs,
                showSearch: true,
                options: transOptions(CustomerData),
                // rules: [{ required: true, message: "请选择客户" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "送修人",
                fieldLabel: Locale["Contact"],
                fieldName: "contact",
                // rules: [{ required: true, message: "请输入送修人" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "送车电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone",
                // rules: [{ required: true, message: "请输入送车电话" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "客户地址",
                fieldLabel: Locale["Address"],
                fieldName: "customerAddress",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="statu-blue" onClick={goVehicle}>{Locale["License Plate"]}</span>,
                fieldName: "licensePlate",//自己定义得字段
                options: mode == "add" ? vehicleOption(vehicleAddAll) : vehicleOption(vehicleEditAll),
                // rules: [{ required: true, message: "请输入车辆牌照" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "VIN码",
                fieldLabel: Locale["VIN"],
                fieldName: "vin",
                // rules: [{ required: true, message: "请输入VIN码" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: '车辆类型',
                fieldLabel: Locale["Vehicle type"],
                fieldName: "vehicleTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
                // rules: [{ required: true, message: "请选择车辆类型" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "车辆型号",
                fieldLabel: Locale["Vehicle Model"],
                fieldName: "vehicleModel",
            }, {
                type: FormItemTypeEnum.Datepicker,
                // fieldLabel: "进厂时间",
                fieldLabel: Locale["Enter Time"],
                showTime: true,
                fieldName: "enterTime",
            }, {
                type: FormItemTypeEnum.Datepicker,
                // fieldLabel: "出厂时间",
                fieldLabel: Locale["Delivery Time"],
                showTime: true,
                fieldName: "deliveryTime",
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: '服务性质',
                fieldLabel: Locale["Service Nature"],
                fieldName: "serviceNatureCode",
                options: getSelectedDictOne(DictCodeEnmu.SERVICE_TYPE),
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: '维修技师',
                fieldName: "technicianCodes",
                allowClear: true,
                mode: "multiple",
                options: transOptions(technicianData),
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "服务地点",
                fieldLabel: Locale["Service Location"],
                fieldName: "serviceLocationCode",
                options: getSelectedDictOne(DictCodeEnmu.SERVICE_ADDRESS),
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: '结算类型',
                fieldLabel: Locale["Payment Type"],
                fieldName: "payType",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                // rules: [{ required: true, message: "该项为必填项" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "去零",
                fieldLabel: Locale["zero-suppression"],
                fieldName: "favorableAmount",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "整单折扣",
                fieldLabel: Locale["Discount Rate"],
                fieldName: "discountRate",
                span: 5,
                labelCol: { offset: 2 },
                suffix: "%"
            },
            {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? Locale["More"] : Locale["Hide"]}</a>,
                fieldName: "none",
                span: 1,
                labelCol: { offset: 5 },
            },
            {
                type: FormItemTypeEnum.Select,
                // fieldLabel: '维修类型',
                fieldLabel: Locale["Service Type"],
                fieldName: "serviceTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE),
                hidden: more,
                // rules: [{ required: true, message: "该项为必填项" }]
            }, 
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "制单时间",
                fieldLabel: Locale["Creation Time"],
                fieldName: "createTime",
                disable: true,
                hidden: more,
                // colClassName: "detail-note-col"
            },
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "故障描述",
                fieldLabel: Locale["Faults"],
                fieldName: "faultDesc",
                span: 12,
                labelCol: { span: 3 },
                hidden: more
                // },
                // {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "去零",
                //     fieldName: "favorableAmount",
                //     span: 12,
                //     labelCol: { span: 3 },
                //     hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "维修方案",
                fieldLabel: Locale["Maintenance Schedule"],
                fieldName: "faultResult",
                span: 12,
                labelCol: { span: 3 },
                hidden: more
            },
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
                span: 12,
                labelCol: { span: 3 },
                hidden: more
            },
        ]
    };

    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        if (mode == DetailType.add) {
            updateAddFormVal(changedValues)
        } else if (mode == DetailType.edit) {
            updatEditFormVal(changedValues)
        }

    }
    const poFromConfig: IYhFormBox = {
        formRef: IYhFormRef,
        labelCol: { span: 6 },
        disabled: true,
        labelAlign: "right",
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}